
import React from "react";
import { FEATURES } from "../../config/features";

type AiFieldHeaderProps = {
  label?: string;
  loading: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export function AiFieldHeader({ label, loading, onClick, disabled }: AiFieldHeaderProps) {
  const isSealed = !FEATURES.AI_LEGACY_ENABLED;

  const handleClick = () => {
      if (isSealed) {
          alert("舊版 AI 功能已封印，請稍候 V2 上線。\n(開發者請至 Debug 頁面測試)");
          return;
      }
      onClick();
  };

  return (
    <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
      {label && <span className="label" style={{ marginBottom: 0 }}>{label}</span>}
      <button
        type="button"
        className="btn-ai-helper"
        style={{
          fontSize: 12,
          padding: '4px 12px',
          color: '#fff',
          background: isSealed || disabled ? '#444' : 'linear-gradient(to right, #A447FF, #FF5CC4)',
          border: 'none',
          borderRadius: '999px',
          cursor: (isSealed || disabled) ? 'not-allowed' : 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          opacity: (isSealed || disabled) ? 0.6 : 1,
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
          transition: 'transform 0.1s ease',
          fontWeight: 500,
          width: 'auto',
          lineHeight: '20px'
        }}
        onClick={handleClick}
        disabled={loading || disabled || isSealed}
        title={isSealed ? "AI V1 已停用" : "點擊生成"}
      >
        {loading ? (
          <>
            <span className="animate-spin">↻</span> 處理中...
          </>
        ) : (
          <>
            <span>✨</span> {isSealed ? "AI 維護中" : "AI 產生草稿"}
          </>
        )}
      </button>
    </div>
  );
}
